"use client"

import React, { useState, useEffect } from "react"
import { Layers } from "lucide-react"

const ModularPartSelector = () => {
  const [parts, setParts] = useState<string[]>([])
  const [activeIndex, setActiveIndex] = useState(0)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const check = () => {
      const g = (window as any).modularGroup
      const vis = (window as any).svgEditorOpen
      if (g && g.children.length > 0 && vis) {
        setParts(g.children.map((c: any) => c.name || "Part"))
        setActiveIndex((window as any).activeModularPartIndex || 0)
        setVisible(true)
      } else {
        setVisible(false)
      }
    }

    check()
    const interval = setInterval(check, 500)
    return () => clearInterval(interval)
  }, [])

  if (!visible) return null

  return (
    <div className="flex items-center gap-1 px-2">
      <Layers className="h-3.5 w-3.5 text-primary/50" />
      {parts.map((name, i) => (
        <button
          key={i}
          onClick={() => {
            ;(window as any).switchModularPart(i)
            setActiveIndex(i)
          }}
          className={`px-2 py-1 text-[10px] font-medium rounded transition-colors ${
            i === activeIndex
              ? "bg-purple-600 text-white"
              : "bg-white/10 text-primary/60 hover:bg-white/20 hover:text-primary"
          }`}
        >
          {name}
        </button>
      ))}
    </div>
  )
}

export default ModularPartSelector
